import axiosInstance from "services/common/axiosInstance";

const handleRequest = async <T>(promise: Promise<any>): Promise<T> => {
  try {
    const response = await promise;
    return response.data;
  } catch (error: any) {
    throw error?.response?.data || error.message;
  }
};

const BASE_URL = "/goal";

export interface GoalCategory {
  id: number;
  category_name: string;
  status: string;
  createdon: string;
  createdby: string;
}

export interface GoalCategoryResponse {
  message: string;
  data: GoalCategory[];
  success: boolean;
}

export interface GoalSubCategory {
    id: number;
    sub_category_name: string;
    category_name: string;
    parent_id: number;
    status: string;
    createdon: string;
    createdby: string;
  }
  
export interface GoalSubCategoryResponse {
    message: string;
    data: GoalSubCategory[];
    success: boolean;
  }

export interface AddGoalCategoryParams {
  category_name: string;
  category_order: number;
}

export interface AddGoalCategoryResponse {
  message: string;
  data: number; // category_id
  success: boolean;
}

export interface UpdateGoalCategoryParams {
  category_name: string;
  category_order: number;
  status: string;
}

export interface UpdateGoalCategoryResponse {
  message: string;
  data?: any;
  success: boolean;
}

export interface DeleteGoalCategoryResponse {
  message: string;
  data?: any;
  success: boolean;
}

export interface AddGoalSubCategoryParams {
  category_name: string;
  category_order: number;
  parent_id: number; // category_id
}

export interface AddGoalSubCategoryResponse {
  message: string;
  data: number; // subcategory_id
  success: boolean;
}

export interface UpdateGoalSubCategoryParams {
  category_name: string;
  category_order: number;
  status: string;
  parent_id: number; // category_id
}

export interface UpdateGoalSubCategoryResponse {
  message: string;
  data?: any;
  success: boolean;
}

export interface DeleteGoalSubCategoryResponse {
  message: string;
  data?: any;
  success: boolean;
}

export const listGoalCategoryAdmin = () =>
  handleRequest<GoalCategoryResponse>(
    axiosInstance.get(`${BASE_URL}/listcategory_admin`)
 );

export const listGoalSubCategoryAdmin = () =>
    handleRequest<GoalSubCategoryResponse>(
      axiosInstance.get(`${BASE_URL}/listsubcategory_admin`)
    );

export const addGoalCategory = (data: AddGoalCategoryParams) =>
  handleRequest<AddGoalCategoryResponse>(
    axiosInstance.post(`${BASE_URL}/addgoalcategory`, data)
  );

export const updateGoalCategory = (category_id: number, data: UpdateGoalCategoryParams) =>
  handleRequest<UpdateGoalCategoryResponse>(
    axiosInstance.put(`${BASE_URL}/updategoalcategory?category_id=${category_id}`, data)
  );

export const deleteGoalCategory = (category_id: number) =>
  handleRequest<DeleteGoalCategoryResponse>(
    axiosInstance.delete(`${BASE_URL}/deletegoalcategory?category_id=${category_id}`)
  );

export const addGoalSubCategory = (data: AddGoalSubCategoryParams) =>
  handleRequest<AddGoalSubCategoryResponse>(
    axiosInstance.post(`/goal/addgoalsubcategory`, data)
  );

export const updateGoalSubCategory = (subcategory_id: number, data: UpdateGoalSubCategoryParams) =>
  handleRequest<UpdateGoalSubCategoryResponse>(
    axiosInstance.put(`/goal/updategoalsubcategory?subcategory_id=${subcategory_id}`, data)
  );

export const deleteGoalSubCategory = (subcategory_id: number) =>
  handleRequest<DeleteGoalSubCategoryResponse>(
    axiosInstance.delete(`/goal/deletegoalsubcategory?subcategory_id=${subcategory_id}`)
  );